import { Step_Down_Transformers } from "gql/api";

export function computeDownTransLabel(
  transformer?: Partial<Step_Down_Transformers> | null
): string {
  if (transformer) {
    return `${transformer.manufacturer} ${transformer.part_number}, ${transformer.kva} KVA, ${transformer.min_secondary_voltage} V - ${transformer.max_secondary_voltage} V`;
  }
  return "";
}
